// Constants
import {
  TOGGLE_INVITE_MODAL,
  UPDATE_INCOMING_INVITE,
  SET_POPUP_LOADING,
  SHOW_INVITATION_STATUS,
} from './constants';
import { INCOMING_POPUP_STEPS } from '../constants';

// Utils
import { getIncomingInvite } from '../api/getIncomingInvite';
import { acceptIncomingInvite } from '../api/acceptInvite';
import { rejectIncomingInvite } from '../api/rejectIncomingInvite';
import { requestStatus } from '../api/requestStatus';

/**
 * =================================================
 * Функционал принятия/отказа в приглашении в семью;
 * =================================================
 */

const updateIncomingInvite = (object) => ({
  type: UPDATE_INCOMING_INVITE,
  data: object,
});

const toggleIncomingInviteModal = (bool) => ({
  type: TOGGLE_INVITE_MODAL,
  data: bool,
});

const setPopupLoading = (bool) => ({
  type: SET_POPUP_LOADING,
  data: bool,
});

const showInvitationStatus = (bool) => ({
  type: SHOW_INVITATION_STATUS,
  data: bool,
});

/**
 * Функция проверяет статус заявки делая polling на бэк проверяя статус заявки;
 */
// Переменная предназначена для подсчета счетчика при polling
const polling = (requestId, timeout, count) => async (dispatch) => {
  dispatch(toggleIncomingInviteModal(false));

  // Определяем временную метку DOMHighResTimeStamp, измеряемую в миллисекундах;
  const performanceTimer = performance.now();

  const response = await requestStatus({ requestId });
  const { data: { isSucceeded, result } } = response;

  if (count >= timeout) {
    dispatch(toggleIncomingInviteModal(true));
    dispatch(updateIncomingInvite({ step: 'error' }));
    return;
  }

  if (result === null) {
    const millisec = performance.now() - performanceTimer;
    const seconds = (millisec / 1000);

    dispatch(polling(requestId, timeout, (count + seconds)));
  } else {
    const step = isSucceeded && result ? 'accepted' : 'error';
    dispatch(toggleIncomingInviteModal(true));
    dispatch(updateIncomingInvite({ step }));
  }
};
/** ================================================= */

/**
 * Функция делает запрос на бэк для проверки приглашения в семью;
 * Если данные пришли, отображаем модальное окно, если нет пропускаем этот фанк;
 */

const getIncomingInviteFetch = () => async (dispatch) => {
  const response = await getIncomingInvite();

  if (response?.data?.result) {
    dispatch(updateIncomingInvite({
      ...response?.data?.result,
      step: INCOMING_POPUP_STEPS.incomingInvite,
    }));

    dispatch(toggleIncomingInviteModal(true));
  }
};
/** ================================================= */

/** Функция принятия предложения приглашения в семью */
const actions = {
  accept: acceptIncomingInvite,
  reject: rejectIncomingInvite,
};

const delay = 30;
const pollingInitValue = 0;

const controlSebInvite = (type, ctn, ssoLink) => async (dispatch) => {
  try {
    dispatch(setPopupLoading(true));

    const data = (ssoLink) ? { ctn, ssoLink } : { ctn };

    const response = await actions[type](data);

    const { data: { isSucceeded, result } } = response;
    if (isSucceeded && result) {
      dispatch(polling(result, delay, pollingInitValue));
    } else {
      const stepType = (isSucceeded) ? INCOMING_POPUP_STEPS[type] : INCOMING_POPUP_STEPS.error;
      dispatch(updateIncomingInvite({ step: stepType }));
    }
  } catch (error) {
    dispatch(updateIncomingInvite({ step: INCOMING_POPUP_STEPS.error }));
  } finally {
    dispatch(setPopupLoading(false));
  }
};
/** ================================================= */

export {
  updateIncomingInvite,
  toggleIncomingInviteModal,
  getIncomingInviteFetch,
  controlSebInvite,
  showInvitationStatus,
};
